export enum AppLayout {
  Mobile = 1,
  Tablet,
  Desktop,
}
